export default function () {

    const vm = this;
    vm.templateChanged = templateChanged;

    function templateChanged(template) {
        vm.onUpdate({ template });
    }
}